import React, { useEffect } from "react";
import { Row, Col } from "reactstrap";
import InvoiceList from "../../components/InvoiceList";
import Text from "../../components/Text";
import {
  getInvoices,
  getInvoicesReset,
} from "../../redux/actions/invoice.actions";
import l10n from "../../localization";
import * as Styled from "./Dashboard.styled";
import { connect } from "react-redux";
import DashboardWidget from "../../components/DashboardWidget";
import { BsInfoSquare } from "react-icons/bs";
import moment from "moment";

function Dashboard({ invoices, user, getInvoices, getInvoicesReset }) {
  useEffect(() => {
    getInvoices(false, false);

    return function cleanup() {
      getInvoicesReset();
    };
    //eslint-disable-next-line
  }, []);

  let waterDebtValue = 0;
  let otherDebtValue = 0;
  let enforcement = false;
  let balanceValue = false;

  if (user) {
    const {
      waterServicesDebt,
      otherServicesDebt,
      isEnforcement,
      balance,
    } = user.data;
    waterDebtValue = waterServicesDebt || 0;
    otherDebtValue = otherServicesDebt || 0;
    enforcement = isEnforcement || false;
    balanceValue = balance || 0;
  }

  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          <Styled.Header>
            <Text type={"h1"}>{l10n.dashboard.welcomeTitle}</Text>
            <Text>{l10n.dashboard.welcomeMessage}</Text>
          </Styled.Header>
        </Col>
      </Row>
      {moment().isBefore('2022-12-14') && (
        <Row>
          <Col md={12}>
            <Styled.HeaderInfo>
              <BsInfoSquare />
              <Styled.Link
                href="https://www.kdvik-rijeka.hr/novosti/252"
                target="_blank"
                rel="noreferrer noopener nofollow"
              >
                <Text>OBAVIJEST O PRIVREMENOM POVEĆANJU CIJENE VODNIH USLUGA ZA STUDENI I PROSINAC 2022.</Text>
              </Styled.Link>
            </Styled.HeaderInfo>
          </Col>
        </Row>
      )}
      <Row>
        <Col xl={2} md={3} sm={6}>
          <DashboardWidget
            title={l10n.widget.balanceOrdinaryDebt}
            value={waterDebtValue}
            description={l10n.widget.waterServices}
            formatPrice
          />
        </Col>
        <Col xl={2} md={3} sm={6}>
          <DashboardWidget
            title={l10n.widget.balanceOrdinaryDebt}
            value={otherDebtValue}
            description={l10n.widget.otherServices}
            formatPrice
          />
        </Col>
        <Col xl={2} md={3} sm={6}>
          <DashboardWidget
            title={l10n.widget.enforcement}
            value={enforcement ? l10n.widget.yes : l10n.widget.no}
            negative={enforcement}
            hideCurrency={true}
          />
        </Col>
        <Col xl={2} md={3} sm={6}>
          <DashboardWidget
            title={
              balanceValue < 0 ? l10n.widget.overpayment : l10n.widget.debit
            }
            value={balanceValue < 0 ? Math.abs(balanceValue) : balanceValue}
            negative={balanceValue > 0}
            formatPrice
          />
        </Col>
      </Row>

      <InvoiceList
        title={l10n.dashboard.outstandingInvoices}
        openInvoices={true}
        invoices={invoices.result}
        loaded={invoices.loaded}
      />
      
    </React.Fragment>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getInvoices: (isPayed, isReversed) =>
      dispatch(getInvoices(isPayed, isReversed)),
    getInvoicesReset: () => dispatch(getInvoicesReset()),
  };
};

export default connect(
  ({ invoices, user: { userData } }) => ({ invoices, user: userData }),
  mapDispatchToProps
)(Dashboard);
